import { Products } from '@site-mate/sitemate-global-shared';
import { Products as InfraProducts } from '@site-mate/sitemate-infra-shared/models';
import { match } from 'ts-pattern';

/**
 * TEMPORARY: bridge between `@site-mate/sitemate-global-shared`'s `Products`
 * enum and `@site-mate/sitemate-infra-shared`'s `Products` enum.
 *
 * The two packages ship their own `Products` enums with diverging supersets
 * (global-shared has `MCP`, infra-shared has `DashpivotMobile`, `Global`,
 * `Infrastructure`, `SitemateOpenApi`). TypeScript enums are nominal, so
 * values from one package can't be assigned to the other even when the
 * underlying string literals match.
 *
 * Gearbelt's DTOs come from global-shared, but `WorkspaceUrlService` from
 * infra-shared expects its own enum — we convert at that boundary here.
 *
 * **To remove when the enums are aligned upstream:**
 * 1. Delete this file.
 * 2. Replace every `toInfraProduct(x)` call site with `x` directly.
 *
 * The call sites are intentionally thin — `grep -r "toInfraProduct" apps/web`.
 */
export function toInfraProduct(product: Products): InfraProducts {
  return match(product)
    .with(Products.Dashpivot, () => InfraProducts.Dashpivot)
    .with(Products.Flowsite, () => InfraProducts.Flowsite)
    .with(Products.Gearbelt, () => InfraProducts.Gearbelt)
    .with(Products.Sitemate, () => InfraProducts.Sitemate)
    .with(Products.SitemateStart, () => InfraProducts.SitemateStart)
    .with(Products.MCP, () => {
      throw new Error(`Cannot map Products.MCP to infra-shared Products — MCP does not have a workspace URL strategy`);
    })
    .exhaustive();
}
